"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { useFormContext } from "react-hook-form";
export default function ContactoYReserva() {
  return <section id="contacto-y-reserva" className="dark bg-background text-foreground py-20 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-start">
          <div className="space-y-6 animate-reveal">
            <div className="space-y-3">
              <h2 className="font-display text-4xl md:text-5xl text-primary">
                Contacto y Reserva
              </h2>
              <p className="text-muted-foreground text-lg">
                Reserve su mesa o contáctenos para cualquier consulta. Estamos aquí para servirle.
              </p>
            </div>

            <FormProvider id="reservation-form" className="space-y-6" formId="contact_reservation_form_home" sectionName="contacto-y-reserva" defaultValues={{
            name: "",
            email: "",
            phone: "",
            reservation_date: "",
            reservation_time: "",
            guests: "",
            message: ""
          }} validationRules={{
            name: {
              required: true,
              minLength: 2
            },
            email: {
              required: true,
              pattern: "email"
            },
            phone: {
              required: true,
              pattern: "phone"
            },
            reservation_date: {
              required: true
            },
            reservation_time: {
              required: true
            },
            guests: {
              required: true
            },
            message: {
              required: false
            }
          }} submitText="Confirmar Reserva" successMessage="¡Gracias! Su reserva ha sido recibida. Le contactaremos pronto para confirmar." errorMessage="No se pudo enviar la reserva. Por favor, inténtelo de nuevo.">
              <ReservationForm />
            </FormProvider>
          </div>

          <div className="space-y-6 animate-reveal delay-200">
            <div className="glass-effect rounded-lg overflow-hidden shadow-strong h-[500px] md:h-[600px] relative">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d880.2906849843734!2d-16.547943330457825!3d28.41495609866295!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xc41ccdd60d79807%3A0x69d5d39e80ca2e93!2sCalle%20Mequinez%2C%2020%2C%2038400%20Puerto%20de%20la%20Cruz%2C%20Santa%20Cruz%20de%20Tenerife%2C%20Spain!5e0!3m2!1sen!2ses!4v1234567890" width="100%" height="100%" style={{
              border: 0,
              filter: "invert(90%) hue-rotate(180deg) saturate(0.8)"
            }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Ubicación de Bodega Julian" />
            </div>

            <div className="card p-6 space-y-4">
              <h3 className="font-display text-2xl text-primary">Información de Contacto</h3>
              
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <MapPin className="size-5 text-primary mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="font-semibold text-foreground">Dirección</p>
                    <p className="text-muted-foreground">Calle Mequinez 20, Puerto de la Cruz, Tenerife, España</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <Phone className="size-5 text-primary mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="font-semibold text-foreground">Teléfono</p>
                    <p className="text-muted-foreground">+34 675 975 715</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <Mail className="size-5 text-primary mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="font-semibold text-foreground">Email</p>
                    <p className="text-muted-foreground">restaurantebodegajulian@gmail.com</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <Clock className="size-5 text-primary mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="font-semibold text-foreground">Horario</p>
                    <p className="text-muted-foreground">Martes a Jueves: 18:00 - 23:00<br />Viernes: 13:00 a 16:00 / 19:00 a 23:00<br />Sábado: 13:00 a 16:00 / 19:00 a 23:00<br /><br />La cocina cierra a las 22:00</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function ReservationForm() {
  const {
    control
  } = useWvcForm();
  const {
    getValues,
    trigger
  } = useFormContext();
  const handleWhatsAppClick = async () => {
    const isValid = await trigger();
    if (!isValid) {
      return;
    }
    const formData = getValues();
    const message = `Hola, quiero hacer una reserva:

Nombre: ${formData.name}
Email: ${formData.email}
Teléfono: ${formData.phone}
Fecha: ${formData.reservation_date}
Hora: ${formData.reservation_time}
Comensales: ${formData.guests}
${formData.message ? `Observaciones: ${formData.message}` : ''}`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/34675975715?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };
  return <Form onSubmit={e => e.preventDefault()}>
      <div className="space-y-5">
        <FormField control={control} name="name" rules={{
        required: "El nombre es obligatorio",
        minLength: {
          value: 2,
          message: "Mínimo 2 caracteres"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Nombre</FormLabel>
              <FormControl>
                <Input placeholder="Juan Pérez" className="bg-muted/30 border-border focus-visible:border-primary transition-all duration-[var(--duration-medium)]" {...field} />
              </FormControl>
              <FormDescription>Introduzca su nombre completo.</FormDescription>
              <FormMessage />
            </FormItem>} />

        <div className="grid md:grid-cols-2 gap-5">
          <FormField control={control} name="email" rules={{
          required: "El correo electrónico es obligatorio",
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Correo electrónico no válido"
          }
        }} render={({
          field
        }) => <FormItem>
                <FormLabel>Correo electrónico</FormLabel>
                <FormControl>
                  <Input type="email" placeholder="juan@example.com" className="bg-muted/30 border-border focus-visible:border-primary transition-all duration-[var(--duration-medium)]" {...field} />
                </FormControl>
                <FormDescription>Necesario para confirmar su reserva.</FormDescription>
                <FormMessage />
              </FormItem>} />

          <FormField control={control} name="phone" rules={{
          required: "El teléfono es obligatorio",
          pattern: {
            value: /^[+]?[\d\s()-]+$/,
            message: "Número de teléfono no válido"
          }
        }} render={({
          field
        }) => <FormItem>
                <FormLabel>Teléfono</FormLabel>
                <FormControl>
                  <Input type="tel" placeholder="+34 600 123 456" className="bg-muted/30 border-border focus-visible:border-primary transition-all duration-[var(--duration-medium)]" {...field} />
                </FormControl>
                <FormDescription>Incluya el prefijo internacional si llama desde fuera de España.</FormDescription>
                <FormMessage />
              </FormItem>} />
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          <FormField control={control} name="reservation_date" rules={{
          required: "La fecha es obligatoria"
        }} render={({
          field
        }) => <FormItem>
                <FormLabel>Fecha de la reserva</FormLabel>
                <FormControl>
                  <Input type="date" className="bg-muted/30 border-border focus-visible:border-primary transition-all duration-[var(--duration-medium)]" {...field} />
                </FormControl>
                <FormDescription>Seleccione el día que desea reservar.</FormDescription>
                <FormMessage />
              </FormItem>} />

          <FormField control={control} name="reservation_time" rules={{
          required: "La hora es obligatoria"
        }} render={({
          field
        }) => <FormItem>
                <FormLabel>Hora de la reserva</FormLabel>
                <FormControl>
                  <select className="flex h-9 w-full min-w-0 rounded-md border border-input bg-muted/30 px-3 py-1 text-base shadow-xs transition-all duration-[var(--duration-medium)] outline-none focus-visible:border-primary focus-visible:ring-ring/50 focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm" {...field}>
                    <option value="">Seleccione una hora</option>
                    <option value="12:00">12:00</option>
                    <option value="12:30">12:30</option>
                    <option value="13:00">13:00</option>
                    <option value="13:30">13:30</option>
                    <option value="14:00">14:00</option>
                    <option value="14:30">14:30</option>
                    <option value="15:00">15:00</option>
                    <option value="19:00">19:00</option>
                    <option value="19:30">19:30</option>
                    <option value="20:00">20:00</option>
                    <option value="20:30">20:30</option>
                    <option value="21:00">21:00</option>
                    <option value="21:30">21:30</option>
                    <option value="22:00">22:00</option>
                  </select>
                </FormControl>
                <FormDescription>Elija la franja horaria deseada.</FormDescription>
                <FormMessage />
              </FormItem>} />
        </div>

        <FormField control={control} name="guests" rules={{
        required: "El número de comensales es obligatorio"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Número de comensales</FormLabel>
              <FormControl>
                <select className="flex h-9 w-full min-w-0 rounded-md border border-input bg-muted/30 px-3 py-1 text-base shadow-xs transition-all duration-[var(--duration-medium)] outline-none focus-visible:border-primary focus-visible:ring-ring/50 focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm" {...field}>
                  <option value="">Seleccione número</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                </select>
              </FormControl>
              <FormDescription>Indique cuántas personas asistirán.</FormDescription>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="message" render={({
        field
      }) => <FormItem>
              <FormLabel>Observaciones / Comentarios</FormLabel>
              <FormControl>
                <Textarea placeholder="Ej.: Necesitamos una mesa cerca de la ventana..." className="bg-muted/30 border-border focus-visible:border-primary transition-all duration-[var(--duration-medium)] min-h-24" {...field} />
              </FormControl>
              <FormDescription>Cualquier petición especial o comentario.</FormDescription>
              <FormMessage />
            </FormItem>} />

        <Button type="button" onClick={handleWhatsAppClick} className="w-full btn-primary hover-lift">
          Confirmar Reserva
        </Button>
      </div>
    </Form>;
}